import GridLayout from "react-grid-layout";
import {
  createMaintenanceDashboardLayoutChangedAction,
  MAINTENANCE_DASHBOARD_LAYOUT_CHANGED,
} from "../actions/maintenanceDashboardLayout";

export interface IMaintenanceDashboardLayoutState extends GridLayout.Layouts {}
export const initialMaintenanceDashboardLayoutState: IMaintenanceDashboardLayoutState = {};

export const maintenanceDashboardLayoutReducer = (
  previousState: IMaintenanceDashboardLayoutState = initialMaintenanceDashboardLayoutState,
  action: ReturnType<typeof createMaintenanceDashboardLayoutChangedAction>
) => {
  switch (action.type) {
    case MAINTENANCE_DASHBOARD_LAYOUT_CHANGED:
      return {
        ...previousState,
        ...action.payload,
      };
  }

  return previousState;
};
